// @ts-nocheck

import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions as loginActions } from '../../actions/login';
import { getUserAccountFormUrl } from '../../config/urls';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';
import { selectUserCC, selectUserSessionId } from '../../selectors/user/userPrimary.selector';
import type { UserAccountPage } from '../../types/user-account';
import { navigateBack } from '../../utils/navigation';

import UserAccount from './UserAccount';
import selectUserAccountProps from './UserAccount.selector';

type UserAccountContainerProps = {
  subpath?: UserAccountPage | null;
};

const UserAccountContainer = (ownProps: UserAccountContainerProps) => {
  const { history, location } = useRouter();
  const dispatch = useDispatch();

  const selectedProps = useSelector(selectUserAccountProps);

  const { jwt } = selectedProps;
  const sessionId = useSelector(selectUserSessionId);
  const cc = useSelector(selectUserCC);

  const actionsProps = useMemo(
    () => ({
      onClose: () => navigateBack({ history, location }),
      doLogout: () => dispatch(loginActions.doLogout({ jwt, sessionId, cc })),
    }),
    [history, location, dispatch, jwt, sessionId, cc],
  );

  const otherProps = {
    userAccountFormUrl: getUserAccountFormUrl(),
  };

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps, otherProps });

  return <UserAccount {...enhancedProps} />;
};

export default UserAccountContainer;
